export const WelcomeTourKey = {
    id: 'welcomeTour',
};
export const InspectorDesignTourKey = {
    id: 'inspectorDesignTour',
};
export const ImportTourKey = {
    id: 'import_tour',
};
export const MigrationTourKey = {
    id: 'migration_tour',
};
//# sourceMappingURL=tourKeys.js.map